module.exports = __webpack_public_path__ + "img/monitoring-car-track.6fd2580e.svg";